__turbopack_context__.v({
  "fade-in": "Heading-module-scss-module__mupH5q__fade-in",
  "fontBrand": "Heading-module-scss-module__mupH5q__fontBrand",
  "heading": "Heading-module-scss-module__mupH5q__heading",
  "highlight": "Heading-module-scss-module__mupH5q__highlight",
  "no-transform": "Heading-module-scss-module__mupH5q__no-transform",
  "rotate": "Heading-module-scss-module__mupH5q__rotate",
  "size-2xl": "Heading-module-scss-module__mupH5q__size-2xl",
  "size-3xl": "Heading-module-scss-module__mupH5q__size-3xl",
  "size-4xl": "Heading-module-scss-module__mupH5q__size-4xl",
  "size-5xl": "Heading-module-scss-module__mupH5q__size-5xl",
  "size-lg": "Heading-module-scss-module__mupH5q__size-lg",
  "size-md": "Heading-module-scss-module__mupH5q__size-md",
  "size-sm": "Heading-module-scss-module__mupH5q__size-sm",
  "size-xl": "Heading-module-scss-module__mupH5q__size-xl",
});
